import { j as C } from "../../_virtual/jsx-runtime.js";
const e = ({
  width: r = 20,
  height: t = 20,
  viewBox: L = "0 0 20 20",
  fill: o = "currentColor",
  ...s
}) => /* @__PURE__ */ C.jsx(
  "svg",
  {
    width: r,
    height: t,
    viewBox: L,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...s,
    children: /* @__PURE__ */ C.jsx(
      "path",
      {
        d: "M13.75 3C16.2814 3 18.3334 5.08333 18.3334 8C18.3334 13.8333 12.0834 17.1667 10 18.4167C8.35221 17.4279 4.09753 15.1358 2.39082 11.3342L0.833374 11.3333V9.66667L1.84208 9.66742C1.72858 9.13608 1.66671 8.58042 1.66671 8C1.66671 5.08333 3.75004 3 6.25004 3C7.80002 3 9.16671 3.83333 10 4.66667C10.8334 3.83333 12.2 3 13.75 3ZM13.75 4.66667C12.8535 4.66667 11.8828 5.14092 11.1785 5.84517L10 7.02369L8.82154 5.84517C8.11727 5.14092 7.14662 4.66667 6.25004 4.66667C4.63259 4.66667 3.33337 6.04708 3.33337 8C3.33337 8.57118 3.40867 9.12633 3.55552 9.667L5.36155 9.66667L7.08337 6.79696L9.58337 10.9636L10.3615 9.66667H14.1667V11.3333H11.3052L9.58337 14.2031L7.08337 10.0364L6.3052 11.3333L4.25662 11.3338C4.91443 12.4781 5.91091 13.5567 7.20432 14.5857C7.82505 15.0796 8.48712 15.5404 9.22179 16.0032C9.47054 16.1599 9.71762 16.3107 10 16.4793C10.2825 16.3107 10.5295 16.1599 10.7783 16.0032C11.513 15.5404 12.175 15.0796 12.7958 14.5857C15.2781 12.6108 16.6667 10.4529 16.6667 8C16.6667 6.03397 15.3859 4.66667 13.75 4.66667Z",
        fill: o
      }
    )
  }
);
export {
  e as default
};
